import { MenuHome } from '@fs/zion-icon'
import { SECTIONS, TOOLS, type ToolId, type ToolSection } from './toolCatalog'

// Restated from @fs/zion-header AdminHeader/types.d.ts (zion-header is only a transitive dependency via zion-root)
export interface SimpleNavItem {
  title: string
  to: string
  Icon?: typeof MenuHome
}
export interface NavMenuItem {
  title: string
  subnav: SimpleNavItem[]
}
export type PortalNavItem = SimpleNavItem | NavMenuItem

const toNavLink = (id: ToolId): SimpleNavItem => ({ title: TOOLS[id].primaryText, to: TOOLS[id].to })

// AdminHeader nav: Home, then a dropdown per home page section, in section order.
// Built from the same SECTIONS as the home page cards so the two cannot disagree
// about what exists.
export default function portalHeaderNav(sections: ToolSection[] = SECTIONS): PortalNavItem[] {
  const home: SimpleNavItem = { title: 'Home', to: '/', Icon: MenuHome }
  const dropdowns: NavMenuItem[] = sections.map((section) => ({
    title: section.heading,
    subnav: section.toolIds.map(toNavLink),
  }))
  return [home, ...dropdowns]
}
